<template>
  <div>
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-xl-12">
              <h4 class="card-title">
                Data
                <router-link
                  v-show="isAdministrator"
                  class="btn btn-sm btn-primary float-right"
                  :to="{ name: 'DataCreate' }"
                  >Create
                </router-link>
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-3 col-xl-3">
              <input
                type="text"
                id="searchCode"
                placeholder="Search Code"
                class="form-control"
                v-model="search.code"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <vue-select
                id="selectLimit"
                name="selectLimit"
                class="form-control"
                placeholder="--- Select namespace ---"
                v-model="search.namespace"
                :options="search.namespaces"
                close-on-select
                :empty-model-value="null"
              ></vue-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-3 col-xl-3">
              <div class="form-group" data-children-count="1">
                <label class="">Limit</label>
                <vue-select
                  id="selectLimit"
                  name="selectLimit"
                  class="form-control"
                  v-model="pagination.limit"
                  :options="pagination.limits"
                  close-on-select
                ></vue-select>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="page" class="">Current Page</label
              ><input
                id="page"
                placeholder="Page"
                min="0"
                :max="pagination.pages"
                type="number"
                class="form-control"
                v-model="pagination.page"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="pages" class="">Pages</label
              ><input
                id="pages"
                readonly=""
                type="number"
                class="form-control"
                v-model="pagination.pages"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="total" class="">Total</label
              ><input
                id="total"
                readonly=""
                type="number"
                class="form-control"
                v-model="pagination.total"
              />
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-1 col-xl-1"
            >
              NAMESPACE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              CODE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              TYPE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              MAKE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              MODEL
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              MODEL TYPE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-2 col-md-1 col-xl-1"
            >
              <span class="float-right">ACTION</span>
            </div>
          </div>

          <div v-for="data in datas" :key="`${data.id}`">
            <div class="row">
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-1 col-xl-1"
              >
                {{ data.namespace }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ data.code }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ data.type }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ data.make }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ data.model }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ data.model_type }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-2 col-md-1 col-xl-1"
              >
                <div role="group" class="float-right btn-group">
                  <router-link
                    v-if="data.is_import === 0"
                    class="btn btn-success btn-sm"
                    :to="{ name: 'DataEdit', params: { id: data.id } }"
                    >Edit</router-link
                  >
                  <button
                    v-if="data.is_import === 0"
                    v-on:click="deleteData(data)"
                    class="btn btn-danger btn-sm"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">Footer</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  deleteData,
  getDatas,
  namespaceList,
} from "../../controllers/data-contoller";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  data: () => {
    return {
      search: {
        code: null,
        namespace: null,
        namespaces: namespaceList,
      },
      pagination: {
        limit: 10,
        page: 1,
        limits: [1, 5, 10, 15, 50, 100],
        pages: 1,
        total: 0,
      },
      datas: [],
    };
  },
  computed: {
    ...mapGetters(["isAdministrator"]),
  },
  created() {
    try {
      this.updateData();
    } catch (e) {
      console.log(e);
    }
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.updateData();
      },
    },
    "pagination.limit"() {
      this.updateData();
    },
    "pagination.page"() {
      this.updateData();
    },
  },
  methods: {
    updateData() {
      setTimeout(async () => {
        const { datas, pagination } = await getDatas(
          this.search,
          this.pagination
        );
        this.datas = datas;
        this.pagination.total = pagination.total;
        this.pagination.pages = pagination.lastPage;
      }, 50);
    },
    deleteData(data) {
      console.log(data);
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Confirm?",
          text: `Are you sure you want to delete: ${data.year} ${data.make} ${data.model} ${data.model_type} (Code: ${data.code}) for ${data.namespace}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const { result } = await deleteData(data.id);
            console.log(result);
            //fire delete in backend
            await swalWithBootstrapButtons.fire(
              `Deleted (${data.id})!`,
              `${data.year} ${data.make} ${data.model} ${data.model_type} (Code: ${data.code}) for ${data.namespace} has been deleted!`,
              "success"
            );
            this.updateData();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            await swalWithBootstrapButtons.fire(
              "Cancelled",
              `${data.year} ${data.make} ${data.model} ${data.model_type} (Code: ${data.code}) for ${data.namespace} has NOT been deleted!`,
              "error"
            );
          }
        });
    },
  },
};
</script>
